import * as Yup from 'yup';

import { requiredRepresentativeTypesRefusalOf } from '../utils/required-representative-types.util';
import { requiredRolesRefusalOf } from '../utils/required-roles.util';
import type { RepresentativeTypeRequirement } from '../utils/required-representative-types.util';
import type { RoleRequirement } from '../utils/required-roles.util';
import type { RoleActor } from '../../../components/Actors/utils/missing-required-roles.util';
import type { TypeActor } from '../../../components/Actors/utils/missing-representative-types.util';

type Memberships = Parameters<typeof requiredRepresentativeTypesRefusalOf>[1] &
  Parameters<typeof requiredRolesRefusalOf>[1];

export const representativesDetailsSchemaOf = ({
  memberships,
  roleRequirement,
  typeRequirement,
}: Readonly<{
  memberships: Memberships;
  roleRequirement?: RoleRequirement;
  typeRequirement?: RepresentativeTypeRequirement;
}>) =>
  Yup.object().shape({
    representatives: Yup.array()
      .test(
        'required-roles',
        ({ path }) => path,
        function hasRequiredRoles(representatives) {
          const refusal = roleRequirement
            ? requiredRolesRefusalOf(
                {
                  ...(this.parent as Partial<RoleActor>),
                  representatives: (representatives ??
                    []) as RoleActor['representatives'],
                },
                memberships,
                roleRequirement,
              )
            : null;

          return refusal ? this.createError({ message: refusal }) : true;
        },
      )
      .test(
        'required-representative-types',
        ({ path }) => path,
        function hasRequiredRepresentativeTypes(representatives) {
          const refusal = typeRequirement
            ? requiredRepresentativeTypesRefusalOf(
                {
                  ...(this.parent as Partial<TypeActor>),
                  representatives: (representatives ??
                    []) as TypeActor['representatives'],
                },
                memberships,
                typeRequirement,
              )
            : null;

          return refusal ? this.createError({ message: refusal }) : true;
        },
      ),
  });
